import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { RootState } from "stores/Store";

import FriendList from "./FriendList";

function Friends() {
  const showFriends = useSelector(
    (state: RootState) => state.uiStateReducer.uiState.showFriends,
  );
  const controls = useAnimation();

  useEffect(() => {
    if (showFriends) {
      controls.start({ left: "91%" });
    } else {
      controls.start({ left: "110%" });
    }
  }, [showFriends]);

  return (
    <motion.section
      className="Friends"
      animate={controls}
      transition={{
        ease: "easeOut",
        duration: 0.4,
        x: { duration: 1 },
        type: "spring",
      }}
      initial={{ right: "-20%" }}
    >
      <FriendList />
    </motion.section>
  );
}

export default Friends;
